import React from 'react';
import { Field } from 'redux-form';
import { checked } from '../../../utils/validate';
import Checkbox from '../../Forms/Checkbox/checkbox';
import RenderChildren from '../../../hoc/renderChildren';

const LegalFieldSet = (props) => {
  const eConsentLink = '/clapply/cyr/econsent.html';

  return (
    <fieldset className="container">
      <legend className="row">Legal</legend>
      <div className="row">
        <div className="col">
          <Field
            name="termsAndConditions"
            component={Checkbox}
            defaultChecked={false}
            validate={[checked]}
            required={true}
            label={<RenderChildren>I agree to the <a href="/clapply/cl/CLCyr.action?legalTerms" data-track="app-links" target="_blank">legal terms &amp; conditions</a></RenderChildren>}
            styles={{
              formGroup: ['p-1']
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <Field
            name="electronicConsent"
            component={Checkbox}
            type="checkbox"
            defaultChecked={false}
            validate={[checked]}
            required={true}
            label={<RenderChildren>I agree to the <a href={eConsentLink} data-track="app-links" target="_blank">e-consent terms &amp; conditions</a></RenderChildren>}
            styles={{
              formGroup: ['p-1']
            }}
          />
        </div>
      </div>
    </fieldset>);
};


export default LegalFieldSet;

